import BdcCreditNote from "../components/Bdc/CreditNote/Editor";

const BdcCreditNotePage = () => <BdcCreditNote />;

export default BdcCreditNotePage;
